import { render } from "./Comp3.vue?vue&type=template&id=6e544a0a&ts=true"
import script from "./Comp3.vue?vue&type=script&lang=ts"
export * from "./Comp3.vue?vue&type=script&lang=ts"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__